import { useFormSetValue } from '@framework/form/hooks/useFormSetValue.ts';
import { useCallback } from 'react';
import { useWatch } from 'react-hook-form';
import { ImportCsvOptionsButton } from '../../common/option-list/ImportCsvOptionsButton.tsx';
import { type IWidgetCsvConfig } from '../../common/option-list/WidgetCsvField.ts';
import { type IAdvancedSelectColumns } from '../IAdvancedSelectColumns.ts';
import { importCsvOptions } from './importCsvOptions.ts';

export interface IAdvancedSelectImportCsvOptionsButtonProps {}

/**
 * Pulsante per l'importazione di opzioni da CSV
 */
export function AdvancedSelectImportCsvOptionsButton(
  props: IAdvancedSelectImportCsvOptionsButtonProps,
) {
  const setValue = useFormSetValue();
  const columns = useWatch({ name: 'columns' }) as
    | IAdvancedSelectColumns[]
    | undefined;

  // Gestisce l'importazione delle opzioni da CSV
  const handleImport = useCallback(
    (config: IWidgetCsvConfig, firstRowAsHeaders = true) => {
      const result = importCsvOptions(config, firstRowAsHeaders, columns);

      setValue('selectedLabelFieldColumns', []);

      setValue('columns', result.columns);
      setValue('options', result.options);
    },
    [columns, setValue],
  );

  return <ImportCsvOptionsButton onImport={handleImport} showHeaderOption />;
}
